"use client";
import { jsx as e, jsxs as n } from "react/jsx-runtime";
import { withCmsDataHandling as f } from "../../../handlers/withCmsDataHandling/withCmsDataHandling.js";
import g from "../../layout/Container/Container.js";
import { useLocaleText as u, Paper as k, Heading as a, Paragraph as o, Group as c, Icon as N, TextLink as j, sharedHandler as y } from "@ingeniorforeningen/figurine-core";
import { forwardRef as I } from "react";
import { uspDeliveryApiParser as L } from "./Usp.helpers.js";
import '../../../assets/Usp.css';const b = "_root_1js6f_2", v = "_heading_1js6f_6", P = "_subtext_1js6f_10", U = "_itemsWrapper_1js6f_16", C = "_item_1js6f_16", W = "_itemIcon_1js6f_29", H = "_itemLink_1js6f_40", s = {
  root: b,
  heading: v,
  subtext: P,
  itemsWrapper: U,
  item: C,
  itemIcon: W,
  itemLink: H
}, i = I((m, l) => {
  const { heading: p, subtext: r, items: d, ..._ } = m, h = u();
  return /* @__PURE__ */ e(g, { ..._, size: "lg", children: /* @__PURE__ */ n(k, { className: s.root, ref: l, children: [
    /* @__PURE__ */ e(a, { align: "center", type: "h2", className: s.heading, text: p }),
    r && /* @__PURE__ */ e(o, { align: "center", className: s.subtext, text: r }),
    /* @__PURE__ */ e("div", { className: s.itemsWrapper, children: d.map((t, x) => /* @__PURE__ */ n(c, { direction: "column", className: s.item, children: [
      /* @__PURE__ */ n(c, { direction: "column", spacing: "xs", children: [
        /* @__PURE__ */ e(
          N,
          {
            name: t.icon,
            color: "secondary",
            size: "xl",
            stroke: 0.6,
            className: s.itemIcon
          }
        ),
        /* @__PURE__ */ e(a, { type: "h2", align: "center", text: t.title || "" }),
        /* @__PURE__ */ e(o, { align: "center", text: t.description || "" })
      ] }),
      t.link && /* @__PURE__ */ e(
        j,
        {
          variant: "component",
          icon: "ChevronRight",
          iconPlacement: "right",
          text: t.link.text || h.seeMore,
          href: t.link.href,
          target: t.link.target,
          className: s.itemLink
        }
      )
    ] }, `upsItem${x}`)) })
  ] }) });
});
i.displayName = "Usp";
const w = f({
  Component: y(i),
  deliveryApiParser: L
});
w.displayName = i.displayName;
export {
  s as U,
  i as _Usp,
  w as default
};
